module.exports = __webpack_public_path__ + "static/media/argentina-icon.a8145b06.svg";